import { render, staticRenderFns } from "./TopClients.vue?vue&type=template&id=354b50ee&scoped=true&"
import script from "./TopClients.vue?vue&type=script&lang=js&"
export * from "./TopClients.vue?vue&type=script&lang=js&"
import style0 from "./TopClients.vue?vue&type=style&index=0&id=354b50ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354b50ee",
  null
  
)

export default component.exports